import { FlexColumn } from "@/components/Flex";
import InputWithMenu from "@/components/InputWithMenu";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";
import { SxProps } from "@mui/material/styles";
import { ChevronDown } from "lucide-react";

const SelectInput = ({
    label,
    options,
    selected,
    onChange,
    placeholder,
    inputSx,
    rootSx,
    ulSx,
}: {
    label: string;
    options: { value: string; label: string }[];
    selected?: { value: string; label: string };
    onChange: (v: string) => void;
    placeholder: string;
    inputSx?: SxProps;
    rootSx?: SxProps;
    ulSx?: SxProps;
}) => {
    const handleChange = (_, newValue) => {
        const isValid = newValue?.value && options.find(o => o.value === newValue.value);
        if (isValid) {
            onChange(newValue ? newValue.value : null);
        }
    };

    return (
        <FlexColumn style={{ gap: spacing.XS_2, width: "100%" }}>
            <span
                className="bodyBold1"
                style={{ textAlign: "left" }}
                data-testid="auto-id-a9169b93-60f1-4960-8b47-ec9124efb1db">
                {label}
            </span>
            <InputWithMenu
                useAutocompleteProps={{ options: options, value: selected, onChange: handleChange }}
                inputProps={{
                    placeholder,
                    sx: {
                        color: themeColors.neutralBlack,
                        width: "100%",
                        padding: `${spacing.XS_2} ${spacing.SM}`,
                        backgroundColor: "transparent",
                        ...inputSx,
                    },
                }}
                ulProps={{
                    sx: { borderRadius: "1.2rem", top: "5.6rem", boxShadow: "0 6px 20px 0 rgba(0,0,0,.08)", ...ulSx },
                }}
                rootProps={{
                    style: {
                        width: "100%",
                        border: `1px solid ${themeColors.pureBlack}`,
                        borderRadius: 999,
                        ...rootSx,
                    },
                }}
                adornment={<ChevronDown size={24} />}
            />
        </FlexColumn>
    );
};

export default SelectInput;
